import { useEffect, useState } from "react";

export const useFeatureFlag = (featureFlag) => {
  const [featureFlags, setFeatureFlags] = useState(() => {
    const storedFlags = localStorage.getItem("featureFlags");
    const storedTimestamp = localStorage.getItem("featureFlagsTimestamp");
    const isExpired = !storedTimestamp || Date.now() - storedTimestamp > 5 * 60 * 1000;
    return storedFlags && !isExpired
      ? JSON.parse(storedFlags)
      : { backGroundImage: true, senjaWidgetFeatureFlag: true };
  });

  useEffect(() => {
    const fetchFeatureFlags = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API}/feature-flags`, {
          headers: { "Content-Type": "application/json" },
        });
        if (response.ok) {
          const data = await response.json();
          const flags = data.reduce((acc, flag) => {
            acc[flag.name] = flag.enabled;
            return acc;
          }, {});
          setFeatureFlags(flags);
          localStorage.setItem("featureFlags", JSON.stringify(flags));
          localStorage.setItem("featureFlagsTimestamp", Date.now());
        }
      } catch (error) {
        console.error("Failed to fetch feature flags:", error);
      }
    };

    const storedTimestamp = localStorage.getItem("featureFlagsTimestamp");
    const isExpired = !storedTimestamp || Date.now() - storedTimestamp > 5 * 60 * 1000;
    if (isExpired) {
      fetchFeatureFlags();
    }

    const interval = setInterval(fetchFeatureFlags, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  return featureFlags[featureFlag] || false;
};